import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Cell } from '@hyphengroup/cag-components';

const Amount = styled.div`
  font-family: ProximaNova;
  font-size: 16px;
  font-weight: 500;
`;

const Note = styled.div`
  font-family: ProximaNova;
  font-size: 11px;
  font-weight: 100;
  line-height: 1.36;
  text-align: center;
`;

const Sub = styled.div`
  font-size: 11px;
  font-weight: 100;
  line-height: 1.36;
  text-align: center;
  margin-bottom: -1.5em;
  margin-right: -13em;
`;

const Comparable = ({ amount, display, subValue }) => (
  <div>
    { subValue && <Sub data-selector-type="sub">{subValue}</Sub> }
    <Cell style={{ textAlign: 'center' }} dataSelectorType="comparable">
      <Amount data-selector-type="inner">{amount}</Amount>
      <Note data-selector-type="inner">{display}</Note>
    </Cell>
  </div>
);

Comparable.propTypes = {
  amount: PropTypes.string,
  display: PropTypes.string,
  subValue: PropTypes.string,
};

export default Comparable;
